import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/img/icons/logo_jidian.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-266f5342")

_pushScopeId("data-v-266f5342")
const _hoisted_1 = /*#__PURE__*/_createVNode("h1", { class: "sidebar-title" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", {
    class: ["sidebar-logo-container", [_ctx.collapse ? 'collapse' : 'notitle']]
  }, [
    _createVNode(_Transition, { name: "sidebarLogoFade" }, {
      default: _withId(() => [
        false
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: "collapse",
              class: "sidebar-logo-link",
              to: "/"
            }))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: "expand",
              class: "sidebar-logo-link",
              to: "/"
            }, {
              default: _withId(() => [
                _hoisted_1
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ], 2))
})